import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import { AssignmentInd } from "@material-ui/icons";
import * as React from "react";
import { FC } from "react";
import { useHistory } from "react-router";
import { routesPaths } from "../../Routes";
import { useGetMyExamSessionsQuery } from "../../api/rtk/MeApi";
import { SwissGermanLocale, SwissTimeZone } from "../../data/constants";
import { ExamSessionViewModel, GetLocalizedName } from "../../model/ExamSessionViewModel";
import { navigateTo } from "../../utils/Navigation";
import { ColumnDefinition, CustomGrid } from "../common/customGrid/CustomGrid";
import TranslatedMessage from "../translations/TranslatedMessage";
import HomeSection from "./HomeSection";

const MyExamSessions: FC = () => {
  const history = useHistory();

  const { data: examSessions, isFetching: isExamSessionsFetching } = useGetMyExamSessionsQuery(undefined);
  const isLoading = isExamSessionsFetching;

  if (!isLoading && examSessions === undefined) {
    return <></>;
  }

  const getRowKey = (row: ExamSessionViewModel) => row.id;

  const columnDefinitions: ColumnDefinition<ExamSessionViewModel>[] = [
    {
      columnKey: "sessionKey",
      columnLabel: <TranslatedMessage id="examSession.field.sessionKey" />,
      cellValue: (c) => GetLocalizedName(c),
    },
    {
      columnKey: "from",
      columnLabel: <TranslatedMessage id="examSession.field.from" />,
      orderValue: (c) => c.from,
      cellValue: (c) => new Date(c.from).toLocaleDateString(SwissGermanLocale, { timeZone: SwissTimeZone }),
    },
    {
      columnKey: "to",
      columnLabel: <TranslatedMessage id="examSession.field.to" />,
      orderValue: (c) => c.to,
      cellValue: (c) => new Date(c.to).toLocaleDateString(SwissGermanLocale, { timeZone: SwissTimeZone }),
    },
  ];

  const gridContent =
    examSessions !== undefined && examSessions.length > 0 ? (
      <CustomGrid<ExamSessionViewModel>
        hideAddButton={true}
        rows={examSessions}
        columnDefinitions={columnDefinitions}
        rowKey={getRowKey}
        tableProps={{ padding: "default" }}
        addButtonTooltip="Add"
        onAddClick={() => {}}
        onRowClick={(_) => navigateTo(routesPaths.expertExamsSchedule(_.id), history)}
      />
    ) : (
      <Typography>
        <TranslatedMessage id="examSessions.noInfo" />
      </Typography>
    );

  return (
    <HomeSection icon={<AssignmentInd />} title={<TranslatedMessage id="home.myExamSessions" />}>
      <Grid container={true} spacing={8}>
        <Grid item={true} xs={12}>
          {isLoading && <LinearProgress variant="query" />}
          {!isLoading && gridContent}
        </Grid>
      </Grid>
    </HomeSection>
  );
};

export default MyExamSessions;
